import { platform } from "@shared/platform-api/requests"
import { FleetChangeInputAdd } from "@shared/platform-api/generated"

export type AddToFleetModernInput = {
  policyId: string
  changes: Array<FleetChangeInputAdd>
  requestedAccessLevel: "standard" | "elevated"
}

export const addToFleet = (
  { policyId, changes, requestedAccessLevel }: AddToFleetModernInput,
  getToken: () => Promise<string>
) =>
  platform(getToken).fleets.changeFleet({
    id: policyId,
    requestBody: {
      requestedAccessLevel,
      changes,
    },
  })
